import { formatNumber } from '@angular/common';
import {
  AEMSnapshot,
  getGenericLabel
} from '@com-delta-idp/mnx-skymiles-shared';
import { EntryItem, Value } from '@com-delta-omnichannel/aura';
import { TYPE } from '../models';
import {
  AccountSnapshotResponse,
  SnapshotRecentAccountActivity
} from '../models/api/account-snapshot.interfaces';

export const getActivityAmounts = (
  values: SnapshotRecentAccountActivity
): Value[] => {
  let totalMilesAmount = 0;
  let totalMQDAmount = 0;

  values.totalActivityRewards.forEach((totalActivityReward) => {
    if (totalActivityReward.balanceTypeCode == 'Miles') {
      totalMilesAmount = totalActivityReward.balanceAmt;
    }

    if (totalActivityReward.balanceTypeCode == 'MQDs') {
      totalMQDAmount = totalActivityReward.balanceAmt;
    }
  });

  const finalValue: Value[] = [];
  finalValue.push({
    amount: formatNumber(
      totalMilesAmount,
      TYPE.LOCALE,
      TYPE.DIGITS_INFO
    ).toString(),
    currency: 'Miles'
  });
  finalValue.push({
    amount:
      '$' +
      formatNumber(totalMQDAmount, TYPE.LOCALE, TYPE.DIGITS_INFO).toString(),
    currency: 'MQDs'
  });

  return finalValue;
};

export const getHeader = (aem: AEMSnapshot): EntryItem => {
  return {
    content: getGenericLabel(aem.subtitle, ''),
    state: '',
    icon: '',
    value: [
      {
        amount: '',
        currency: ''
      }
    ],
    ariaLabel: {
      icon: ''
    },
    border: 'none'
  };
};

export const validateActivity = (
  snapshot: AccountSnapshotResponse
): boolean => {
  return snapshot &&
    snapshot.recentActivities &&
    snapshot.recentActivities.length
    ? true
    : false;
};
